'use client';

import { HeaderContact, HeaderContactMobile } from '@/components/CustomLayout/CustomHeaderContact';
import { IContactItem } from '@/types/layout';
import { Fragment, useEffect, useState } from 'react';

export interface IContactItemsProps {
  contactItems: IContactItem[];
}

export const ContactItems = ({ contactItems }: IContactItemsProps) => {
  const [contactsPortalNode, setContactsPortalNode] = useState<HTMLElement | null>(null);
  const [hasContactsOverride, setHasContactsOverride] = useState(false);

  const [mobileContactPortalNode, setMobileContactPortalNode] = useState<HTMLElement | null>(null);
  const [hasMobileContactOverride, setHasMobileContactOverride] = useState(false);

  useEffect(() => {
    if (!contactsPortalNode) return;

    const updateOverrideState = () => setHasContactsOverride(contactsPortalNode.childElementCount > 0);
    updateOverrideState();

    const observer = new MutationObserver(updateOverrideState);
    observer.observe(contactsPortalNode, { childList: true });
    return () => observer.disconnect();
  }, [contactsPortalNode]);

  useEffect(() => {
    if (!mobileContactPortalNode) return;

    const updateOverrideState = () => setHasMobileContactOverride(mobileContactPortalNode.childElementCount > 0);
    updateOverrideState();

    const observer = new MutationObserver(updateOverrideState);
    observer.observe(mobileContactPortalNode, { childList: true });
    return () => observer.disconnect();
  }, [mobileContactPortalNode]);

  const contactItemsBase = contactItems.filter((item) => !item.custom_item || item.always_include);

  return (
    <Fragment>
      {/* Desktop Contact Items */}
      {!hasContactsOverride && <HeaderContact contactItems={contactItemsBase} />}
      <div id="header-contacts-portal-target" ref={setContactsPortalNode} className="contents" />

      {/* Mobile Contact Item */}
      {!hasMobileContactOverride && (
        <HeaderContactMobile contactItems={contactItemsBase.filter((item) => item.show_on_mobile)} />
      )}
      <div id="header-mobile-contact-portal-target" ref={setMobileContactPortalNode} className="contents" />
    </Fragment>
  );
};
